import MedicalCircle from "./SVG/hospitalBoard.svg?react";

const MedicalCircleIcon = () => {
  return <MedicalCircle />;
};

export default MedicalCircleIcon;
